<script lang="ts">
	import { create } from "@bufbuild/protobuf";
	import { Heading, Img } from "flowbite-svelte";
	import { getContext } from "svelte";
	import { readable, type Writable } from "svelte/store";
	import { twMerge, type ClassNameValue } from "tailwind-merge";
	import { LandingPageSchema, type Suite } from "#gen/bundles/v1/bundle_pb.js";
	import { Mode } from "#gen/bundles/v1/service_pb.js";
	import type { AssetLoad } from "#lib/api/bundles.js";
	import type { EntryAsset } from "#lib/assetManager.js";
	import P from "#lib/components/P.svelte";
	import { createInterpolatedLandingPageStore } from "#lib/stores/asset.js";
	import { createDataItem } from "#lib/stores/suite.js";
	import type { TokenProvider } from "#lib/tokenProvider.js";

	interface Props {
		suite: Writable<Suite>;
		initialAsset?: AssetLoad;
		mode: Mode;
		class?: ClassNameValue;
	}

	const tokenProvider: Writable<TokenProvider> = getContext("tokenProvider");
	const entryAsset: Writable<EntryAsset | undefined> = getContext("entryAsset");

	const { suite, initialAsset, mode = Mode.LIVE, class: className }: Props = $props();

	const landingPage = $derived(createInterpolatedLandingPageStore(tokenProvider, suite, entryAsset, initialAsset?.asLandingPage() ?? readable(create(LandingPageSchema)), mode));
	const image = $derived($landingPage?.images?.[0]);
	const data = $derived(createDataItem($suite, initialAsset));
</script>

<div class={twMerge(className, "relative h-full")}>
	<div class="flex h-full flex-col">
		<div class="flex-none px-4 pt-6 pb-4">
			<Heading tag="h2" class="text-left">{data.successHeader}</Heading>
			<P size="lg" secondary>{data.successText}</P>
		</div>
		{#if image?.url}
			<div class="grow">
				<Img referrerpolicy="no-referrer" class="h-full w-full overflow-clip rounded-2xl object-cover" src={image.url} alt={image.altText} />
			</div>
		{/if}
	</div>
</div>
